<template>
  <div
    class="step-matrix-body"
    >
    <v-icon small v-if="value" :color="color">check_circle</v-icon>
  </div>
</template>
<script>
  export default {
    props: ['color', 'value'],
    data: () => ({
    }),
  }
</script>
<style>
  .step-matrix-body {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    border-bottom: 1px solid #121212;
    border-right: 1px solid #121212;
  }
</style>
